import React from 'react';
import PropTypes from 'prop-types';
import { Context } from '@front10/helpers/dist/Context';
import { Listbox } from '../../lab/Listbox';

const TripDuration = (props, ref) => {
  const {
    value,
    tripDurationRangeValues,
    filterButtonIconProps,
    onChange,
    showDescriptionLabel = false
  } = props;

  const { translate } = React.useContext(Context);
  const getOptions = (options) => {
    return options.map((option) => ({
      label: translate(option.name, option.name),
      value: JSON.stringify(option.value),
      key: option.key
    }));
  };
  const listRef = React.useRef(null);

  React.useImperativeHandle(
    ref,
    () => ({
      focusToggleElement: () => {
        listRef.current.focusToggleElement();
      }
    }),
    []
  );

  return (
    <Listbox
      filterButtonIconProps={filterButtonIconProps}
      ref={listRef}
      label={translate('cmp-trip-duration-label', 'Number of Nights')}
      layout="standard"
      options={getOptions(tripDurationRangeValues ? tripDurationRangeValues : props.options)}
      key={Math.floor(Math.random() * 100 + 1)}
      defaultValue={JSON.stringify(value)}
      onChange={(newValue) => {
        onChange(JSON.parse(newValue));
      }}
      prefixSelectedItem={
        showDescriptionLabel
          ? translate('cmp-trip-duration-filter-prefix-selected-item', 'Number of Nights')
          : null
      }
    />
  );
};

TripDuration.propTypes = {
  value: PropTypes.object,
  options: PropTypes.array,
  onChange: PropTypes.func,
  filterButtonIconProps: PropTypes.any
};

TripDuration.defaultProps = {
  value: {},
  options: [],
  onChange: () => {},
  filterButtonIconProps: {}
};

export default React.forwardRef(TripDuration);
